// Recidiviz - a data platform for criminal justice reform
// Copyright (C) 2025 Recidiviz, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// =============================================================================

import { FeatureVariant } from "../../../../../../RootStore/types";
import { ApiOpportunityConfiguration } from "../../ApiOpportunityConfigurationImpl";

export class UsTxAnnualReportStatusConfiguration extends ApiOpportunityConfiguration {
  // TODO(#9880): Add custom denial reason snooze lengths to admin panel
  get maxSnoozeDaysByDenialReason(): Record<string, number | undefined> {
    const snoozeLengthOverrides = {
      DISCRETION: 365,
    };

    return { ...super.maxSnoozeDaysByDenialReason, ...snoozeLengthOverrides };
  }

  get markSubmittedOnFormDownload() {
    return false;
  }

  get inverseFeatureVariant() {
    return "usTxAnnualReportStatusV2" as FeatureVariant;
  }
}
